"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

exports.default = function (props) {
  var title = props.title,
      type = props.type,
      className = props.className;

  var getComponentByType = function getComponentByType() {
    if (type === 'subtitle') return 'h2';
    if (type === 'groupTitle') return 'h3';
    return 'h1';
  };

  var getVariantByType = function getVariantByType() {
    if (type === 'subtitle') return 'h5';
    if (type === 'groupTitle') return 'h6';
    return 'h4';
  };

  return react_1.default.createElement(Typography_1.default, {
    component: getComponentByType(),
    variant: getVariantByType(),
    className: "".concat(className ? ' ' + className : '')
  }, title);
};